import { render } from "./hotel_info.vue?vue&type=template&id=3f95caf2"
import script from "./hotel_info.vue?vue&type=script&lang=js"
export * from "./hotel_info.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__